import { useQuery } from 'react-query'
import useCurrentUser from '../use-current-user'
import useCacheKeys from '../use-cache-keys'
import useApi from '../use-api'
import useCache from '../use-cache'
import { get, find } from 'lodash'
import moment from 'moment'
import useSystemSettings from '../use-system-settings'

const useCourse = ({
    id: courseId,
    onReload = () => {}
}) => {
    const { api, url, endpoints, time } = useApi()
    const cacheKeys = useCacheKeys()
    const { id: currentUserId } = useCurrentUser()
    const { data, isLoading } = useQuery(
        [cacheKeys.COURSES, courseId],
        () => api.get(url(endpoints.course, { courseId })),
        {
            enabled: Boolean(courseId),
            staleTime: time.MINUTE
        }
    )

    const { clearCache } = useCache({ key: [cacheKeys.COURSES, courseId], onReload })
    const { isLoadingSystemSettings, courseDropLeadTime } = useSystemSettings()

    const course = data || {}
    const enrollees = get(course, 'enrollees', [])
    const maxCapacity = get(course, 'maxCapacity', 0)
    const date = get(course, 'date')
    const canSchedule = date ? !moment(date).isBefore(moment()) : false
    const isEnrolled = Boolean(find(enrollees, { id: currentUserId }))
    const isMaxCapacity = enrollees.length >= maxCapacity
    const canEnroll = !isEnrolled && canSchedule && !isMaxCapacity
    const hasDropTime = moment(course.date).subtract(courseDropLeadTime, 'hours').isAfter(moment())
    const canDrop = isEnrolled && hasDropTime

    return {
        isBusy: isLoading || isLoadingSystemSettings,
        course: {
            canSchedule,
            isEnrolled,
            isMaxCapacity,
            canEnroll,
            canDrop,
            ...course
        },
        reloadCourse: clearCache,
    }
}

export default useCourse